import axios from "axios";
import { getAdminToken } from "./authStorage";

const apiAdm = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});

apiAdm.interceptors.request.use((config) => {
    const token = getAdminToken();

    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
});

export default apiAdm;
